module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/bulb-3649ff2900d0254dcfb6c1e7ed65968d.svg";